import React from "react";
import { MaterialReactTable } from "material-react-table";
import { sharedTableProps } from "../shared/tableProps";
import AddToolbarLink from "../shared/AddToolbarLink";

const ApiConfigViewTable = ({ data, mainColumns }) => (
  <MaterialReactTable
    {...sharedTableProps}
    columns={mainColumns}
    data={data}
    renderTopToolbarCustomActions={() => (
      <AddToolbarLink to="/AddAPIConfig" label="Add API Config" />
    )}
  />
);

export default ApiConfigViewTable;
